
import { mapState, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapState(['account']),
    ...mapGetters({
      userRoleIs: 'account/userRoleIs',
      userRole: 'account/userRole',
      userRoleName: 'account/userRoleName',
      userIsAdmin: 'account/userIsAdmin',
      userId: 'account/userId',
    }),
  },
}


// WEBPACK FOOTER //
// ./src/mixins/usesAccountInfo.js